//export const API_URL = 'https://pal.diginestsolutions.in/public/api';
//export const API_URL = 'https://192.168.1.54/public/api/';
 
// 1- corporate, 2-ta, 3-customer, 4 -supplier
 
export const env = "client"
 
const URLS = {
    // client: "https://redace.otademo.com/",
    client: "https://booking.rlimo.sg/",
    // client: "http://localhost/redace/public",
}
 
const url = {
    // client:"https://redace.otademo.com/public/api",
    client:"https://booking.rlimo.sg/public/api",
    // client: "http://localhost/redace/public/api",
}
 
const viewurl = {
    // client:"https://redace.otademo.com/public/auth/",  
    client:"https://booking.rlimo.sg/public/auth/",  
    // client:"http://localhost/redace/public/auth/",  
}
 
const image = {
    // client: "https://redace.otademo.com/assets/img/vehicles/",
    client: "https://booking.rlimo.sg/assets/img/vehicles/",
    // client: "http://localhost/redace/assets/img/vehicles/",
 
}
 
const noshow = {
    // client: "https://redace.otademo.com/storage/",
    client: "https://booking.rlimo.sg/storage/",
    // client: "http://localhost/redace/storage/",
 
}
 
const vehicleType = {
    // client: "https://redace.otademo.com/public/assets/img/",
    client: "https://booking.rlimo.sg/public/assets/img/",
    // client: "http://localhost/redace/public/assets/img/",
}
 
const key = {
    client:"nGw3tbaew9KgjGiXf3JwVnNEDUS4pmsA",
}
 
//'https://apidev.myfutton.com' //Dev mode= http://apidev.myfutton.com //Live Mode='http://api.myfutton.com';
//Dev mode= http://apidev.myfutton.com/api/v1/student //Live Mode=http://api.myfutton.com/api/v1/student';
 
export const BASE_URL = URLS[env]
export const IMAGE_URL = image[env]
export const NO_SHOW_IMG = noshow[env]
export const VIEW_URL = viewurl[env]
export const VEHICLETYPE_IMG = vehicleType[env]
 
 
export const API_URL = `${url[env]}`
export const API_KEY = `${key[env]}`
 